import { Button } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .button' ) )
     .forEach( buttonNode => new Button( buttonNode ) )
